"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Observable = void 0;

var _observer = require("./observer");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var NOOP = function NOOP() {}; // TODO: when needed handle complete() and error()


var Observable = /*#__PURE__*/function () {
  function Observable(subscribeFn) {
    _classCallCheck(this, Observable);

    this._subscribe = subscribeFn;
    this.index = 0;
  }

  _createClass(Observable, [{
    key: "subscribe",
    value: function subscribe() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var _args$ = args[0],
          next = _args$ === void 0 ? NOOP : _args$,
          _args$2 = args[1],
          error = _args$2 === void 0 ? NOOP : _args$2,
          _args$3 = args[2],
          complete = _args$3 === void 0 ? NOOP : _args$3;

      if (next instanceof _observer.Observer) {
        return this._subscribe(args[0]);
      }

      if (typeof args[0] === 'function') {
        return this._subscribe(new _observer.Observer({
          next: args[0],
          error: NOOP,
          complete: NOOP
        }));
      }

      if (_typeof(args[0]) && typeof args[0].next === 'function') {
        return this._subscribe(new _observer.Observer(_objectSpread(_objectSpread({}, args[0]), {}, {
          error: error,
          complete: complete
        })));
      }

      var err = new Error('You need to specify a next function, object with next,error and complete or Observer object');
      err.name = '[Observable] No valid argument in subscribtion';
      throw err;
    }
  }, {
    key: "increaseIndex",
    value: function increaseIndex() {
      this.index += 1;
    }
  }, {
    key: "bufferCount",
    value: function bufferCount() {
      var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var parentObservable = this; // eslint-disable-next-line prefer-arrow-callback, no-new

      return new Observable(function subscribeFn(nextObserver) {
        var buffer = [];
        var observer = new _observer.Observer({
          next: function next(value) {
            buffer = [value].concat(buffer).slice(0, count);
            nextObserver.next([value].concat(_toConsumableArray(buffer)), parentObservable.index);
            parentObservable.increaseIndex();
          },
          error: nextObserver.error,
          complete: nextObserver.complete
        });
        return parentObservable.subscribe(observer);
      });
    }
  }, {
    key: "map",
    value: function map(iteratee) {
      var parentObservable = this; // eslint-disable-next-line prefer-arrow-callback, no-new

      return new Observable(function subscribeFn(nextObserver) {
        var observer = new _observer.Observer({
          next: function next(value) {
            var result = iteratee(value, parentObservable.index);
            parentObservable.increaseIndex();
            return nextObserver.next(result);
          },
          error: nextObserver.error,
          complete: nextObserver.complete
        });
        return parentObservable.subscribe(observer);
      });
    }
  }, {
    key: "filter",
    value: function filter(selectFn) {
      var parentObservable = this; // eslint-disable-next-line prefer-arrow-callback, no-new

      return new Observable(function subscribeFn(nextObserver) {
        var observer = new _observer.Observer({
          next: function next(value) {
            if (selectFn(value, parentObservable.index)) {
              nextObserver.next(value);
            }

            parentObservable.increaseIndex();
          },
          error: nextObserver.error,
          complete: nextObserver.complete
        });
        return parentObservable.subscribe(observer);
      });
    }
  }, {
    key: "do",
    value: function _do(cb) {
      var parentObservable = this; // eslint-disable-next-line prefer-arrow-callback, no-new

      return new Observable(function subscribeFn(nextObserver) {
        var observer = new _observer.Observer({
          next: function next(value) {
            cb(value, parentObservable.index);
            nextObserver.next(value);
            parentObservable.increaseIndex();
          },
          error: nextObserver.error,
          complete: nextObserver.complete
        });
        return parentObservable.subscribe(observer);
      });
    }
  }, {
    key: "filterUnchanged",
    value: function filterUnchanged() {
      var compareFn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (p, n) {
        return p === n;
      };
      var parentObservable = this; // eslint-disable-next-line prefer-arrow-callback, no-new

      return new Observable(function subscribeFn(nextObserver) {
        var previousVal;
        var observer = new _observer.Observer({
          next: function next(value) {
            var isUnchanged = compareFn(value, previousVal, parentObservable.index);
            parentObservable.increaseIndex();
            if (isUnchanged) return;
            previousVal = value;
            nextObserver.next(value);
          },
          error: nextObserver.error,
          complete: nextObserver.complete
        });
        var unsubscribe = parentObservable.subscribe(observer);
        return function unsubscribeFn() {
          previousVal = undefined;
          unsubscribe();
        };
      });
    }
  }]);

  return Observable;
}();

exports.Observable = Observable;
//# sourceMappingURL=observable.js.map